import React, { Dispatch, SetStateAction } from 'react';
 
const useStateWithLocalStorage = (localStorageKey: string) : [string, Dispatch<SetStateAction<string>>] => {
  const [value, setValueInternal] = React.useState(
    localStorage.getItem(localStorageKey) || ''
  );

  const setValue = React.useCallback((newValue: any) => {
    setValueInternal(newValue);
    localStorage.setItem(localStorageKey, newValue);
  }, [localStorageKey]);
 
  return [value, setValue];
};

export default useStateWithLocalStorage;